var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44615 9.42917L9.44617 9.42919L10.9045 10.8867C11.3575 11.3397 12.1419 11.0237 12.1419 10.3743V9.64096H17.0419C17.4421 9.64096 17.7669 9.31619 17.7669 8.91596C17.7669 8.51573 17.4421 8.19096 17.0419 8.19096H12.1419V7.45763C12.1419 6.81202 11.3583 6.48871 10.9044 6.94536C10.9043 6.9454 10.9043 6.94544 10.9043 6.94547L9.44615 8.40358C9.16294 8.6868 9.16294 9.14595 9.44615 9.42917Z",
    fill: "#21C463",
    stroke: "#21C463",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8587 11.6249V12.3583H9.95874C9.55851 12.3583 9.23374 12.683 9.23374 13.0833C9.23374 13.4835 9.55851 13.8083 9.95874 13.8083H14.8587V14.5416C14.8587 15.1891 15.6429 15.5072 16.0961 15.054L17.5545 13.5956C17.8377 13.3124 17.8377 12.8533 17.5545 12.57L17.5544 12.57L16.0961 11.1125C16.0961 11.1125 16.0961 11.1125 16.0961 11.1125C15.6417 10.6582 14.8587 10.9796 14.8587 11.6249Z",
    fill: "#21C463",
    stroke: "#21C463",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5873 15.3207L13.5502 15.225H13.4475H12.6667H12.5167V15.375V18.5C12.5167 18.8772 12.2105 19.1833 11.8333 19.1833H3.5C3.12284 19.1833 2.81667 18.8772 2.81667 18.5V3.5C2.81667 3.12284 3.12284 2.81667 3.5 2.81667H3.91667C4.29382 2.81667 4.6 3.12284 4.6 3.5C4.6 4.04284 5.04049 4.48333 5.58333 4.48333H9.75C10.2928 4.48333 10.7333 4.04284 10.7333 3.5C10.7333 3.12284 11.0395 2.81667 11.4167 2.81667H11.8333C12.2105 2.81667 12.5167 3.12284 12.5167 3.5V5.5425V5.62394L12.585 5.6683C12.9634 5.91408 13.2527 6.26686 13.4127 6.67925L13.4498 6.775H13.5525H14.3333H14.4833V6.625V3.5C14.4833 2.03882 13.2945 0.85 11.8333 0.85H3.5C2.03882 0.85 0.85 2.03882 0.85 3.5V18.5C0.85 19.9612 2.03882 21.15 3.5 21.15H11.8333C13.2945 21.15 14.4833 19.9612 14.4833 18.5V16.4575V16.3761L14.415 16.3317C14.0366 16.0859 13.7473 15.7331 13.5873 15.3207Z",
    fill: "#21C463",
    stroke: "#21C463",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMoney);
export default __webpack_public_path__ + "static/media/mobile-money.90d7d87f80a09b04874a8b2a2ce35105.svg";
export { ForwardRef as ReactComponent };